import {
    Box,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import { Refresh, Search } from "@mui/icons-material";

interface LogFiltersProps {
    searchQuery: string;
    onSearchChange: (value: string) => void;
    logLevelFilter: "all" | "info" | "debug" | "warn" | "error";
    onLogLevelChange: (value: "all" | "info" | "debug" | "warn" | "error") => void;
    hideDebug: boolean;
    onHideDebugChange: (value: boolean) => void;
    autoRefresh: boolean;
    onAutoRefreshChange: (value: boolean) => void;
    onRefresh: () => void;
    loading: boolean;
}

const LogFilters = ({
    searchQuery,
    onSearchChange,
    logLevelFilter,
    onLogLevelChange,
    hideDebug,
    onHideDebugChange,
    autoRefresh,
    onAutoRefreshChange,
    onRefresh,
    loading,
}: LogFiltersProps) => (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <TextField
            size="small"
            placeholder="Search logs or correlationId..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            sx={{ minWidth: 250 }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Search sx={{ fontSize: 20 }} />
                    </InputAdornment>
                ),
            }}
        />
        <FormControl size="small">
            <InputLabel>Level</InputLabel>
            <Select
                value={logLevelFilter}
                label="Level"
                onChange={(e) => onLogLevelChange(e.target.value as typeof logLevelFilter)}
                sx={{ minWidth: 120 }}
            >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="info">Info</MenuItem>
                <MenuItem value="debug">Debug</MenuItem>
                <MenuItem value="warn">Warn</MenuItem>
                <MenuItem value="error">Error</MenuItem>
            </Select>
        </FormControl>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2">Hide Debug</Typography>
            <Switch
                checked={hideDebug}
                onChange={(e) => onHideDebugChange(e.target.checked)}
                size="small"
            />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2">Auto-refresh</Typography>
            <Switch
                checked={autoRefresh}
                onChange={(e) => onAutoRefreshChange(e.target.checked)}
                size="small"
            />
        </Box>
        <IconButton onClick={onRefresh} disabled={loading}>
            <Refresh />
        </IconButton>
    </Box>
);

export default LogFilters;
